import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";
import config from "./config";
import MenuItem from "../MenuItem";

class Menu extends PureComponent {
  render() {
    const { availableMenu } = config;
    return (
      <div className="Menu">
        {availableMenu.map(menu => (
          <MenuItem key={menu.id} menu={menu} />
        ))}
      </div>
    );
  }
}

export default Menu;
